export default class LanguageService {


  constructor() {
    this.getBrowserLanguage()
  }

  public getBrowserLanguage():string {
    const browserLanguage = (navigator.language || navigator.languages[0]).split("-")[0];
    console.log("Browser Language:", browserLanguage);
    return browserLanguage
  }

}